import { FieldComponent } from 'libs/form';
import { ZoneInputBox } from '../styled';
import { FormWrapper, PeriodsWrapper, Headers, Header, ZoneLabel, Inputs, Interface, Wrapper } from './two-periods-tariffication.styled';

export const TwoPeriodsTariffication = (props) => {
  const { color, display } = props;

  /**
   * get periods
   * @returns
   */
  const getPeriodsEl = () => {
    const labels = ['День', 'Ночь'];
    return [0, 1].map((idx) => {
      const label = labels[idx];
      const name = 'periods[' + idx + '].amount';
      return (
        <FormWrapper key={idx}>
          <PeriodsWrapper>
            {!idx && (
              <Headers>
                <Header>Период</Header>
                <Header>Тариф</Header>
              </Headers>
            )}
            <Inputs>
              <ZoneLabel>{label}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent type="text" name={name} naturalNumber maxValueLength={5} disabled={props.disabled} />
                <span>₽</span>
              </ZoneInputBox>
            </Inputs>
          </PeriodsWrapper>
        </FormWrapper>
      );
    });
  };

  const periodsEl = getPeriodsEl();
  return (
    <Interface color={color} display={display ? 'block' : 'none'}>
      <Wrapper>{periodsEl}</Wrapper>
    </Interface>
  );
};
